/*
 * ZAISEN bundle controls for the EXISTING Add to Cart + Buy Now buttons.
 * Two curated optional additions; native 15% / 25% product discount codes.
 * Free shipping is either earned via the normal country minimum or the
 * separate qualifying bundle shipping code. Only eligible destinations are
 * shown as free. No separate bundle purchase button is rendered.
 *
 * Shopify Ajax Cart API: POST cart/add.js with items, followed by
 * POST cart/update.js with comma-separated discount codes.
 * Intercept theme form only when extras are checked. Main-only actions
 * continue to use their original native theme handlers.
 */
(() => {
  if (customElements.get('zs-bundle-builder')) return;

  // Presentation-only translations; prices, cart rules and discount logic remain unchanged.
  const bundleCopy = {
    en: {
      inBundle:'Already in your bundle', choose:'Choose piece ↗', change:title=>'Change '+title+' in your bundle',
      option:title=>'Choose an option for '+title, save:'Save ', saveCaps:'SAVE ',
      off:'% OFF', max:'UP TO 25% OFF',
      savings:(rate,count)=>'Save '+rate+'% on '+count+' selected products',
      savingsHint:'Add 1 piece: 15% off · Add both: 25% off',
      estimated:'EST. ', progressUnlocked:'Free shipping unlocked',
      progressTo:'Free shipping progress to ', minAtCheckout:'Free shipping minimum confirmed at checkout',
      calculated:'SHIPPING CALCULATED AT CHECKOUT', normalFree:'YOUR ORDER QUALIFIES FOR FREE SHIPPING (',
      bundleFree:'YOUR BUNDLE QUALIFIES FOR FREE SHIPPING', freeFrom:'FREE SHIPPING ON ORDERS ',
      minConfirmed:'FREE SHIPPING MINIMUM CONFIRMED AT CHECKOUT',
      variantError:'Please choose an available variant for each selected product.',
      updating:'Your main product option is updating. Please try again.',
      addError:'Could not add the selected products.',
      unknownError:'Something went wrong. Please try again.',
      cartUpdate:'Could not update the cart drawer.',
      cartLoad:'Could not load the updated cart drawer.',
      cartUnavailable:'Cart drawer content unavailable.'
    },
    de: {
      inBundle:'Bereits im Bundle', choose:'Produkt auswählen ↗', change:title=>'Im Bundle ändern: '+title,
      option:title=>'Option wählen für '+title, save:'Gespart: ', saveCaps:'GESPART: ',
      off:'% RABATT', max:'BIS ZU 25 % RABATT',
      savings:(rate,count)=>rate+' % Rabatt auf '+count+' ausgewählte Produkte',
      savingsHint:'1 Stück hinzufügen: 15 % Rabatt · Beide hinzufügen: 25 % Rabatt',
      estimated:'CA. ', progressUnlocked:'Kostenloser Versand erreicht',
      progressTo:'Fortschritt zum kostenlosen Versand: ', minAtCheckout:'Mindestwert für kostenlosen Versand an der Kasse bestätigt',
      calculated:'VERSANDKOSTEN AN DER KASSE', normalFree:'IHRE BESTELLUNG HAT KOSTENLOSEN VERSAND (',
      bundleFree:'IHR BUNDLE HAT KOSTENLOSEN VERSAND', freeFrom:'KOSTENLOSER VERSAND AB ',
      minConfirmed:'MINDESTWERT FÜR KOSTENLOSEN VERSAND AN DER KASSE',
      variantError:'Bitte wählen Sie für jedes Produkt eine verfügbare Variante.',
      updating:'Die Produktauswahl wird aktualisiert. Bitte erneut versuchen.',
      addError:'Die ausgewählten Produkte konnten nicht hinzugefügt werden.',
      unknownError:'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      cartUpdate:'Der Warenkorb konnte nicht aktualisiert werden.',
      cartLoad:'Der aktualisierte Warenkorb konnte nicht geladen werden.',
      cartUnavailable:'Der Warenkorb ist momentan nicht verfügbar.'
    },
    fr: {
      inBundle:'Déjà dans votre lot', choose:'Choisir cette pièce ↗', change:title=>'Changer dans votre lot : '+title,
      option:title=>'Choisir une option pour '+title, save:'Économie : ', saveCaps:'ÉCONOMIE : ',
      off:'% DE RÉDUCTION', max:'JUSQU’À 25 % DE RÉDUCTION',
      savings:(rate,count)=>rate+' % de réduction sur '+count+' articles sélectionnés',
      savingsHint:'Ajoutez 1 pièce : 15 % de réduction · Ajoutez les deux : 25 %',
      estimated:'EST. ', progressUnlocked:'Livraison gratuite obtenue',
      progressTo:'Progression vers la livraison gratuite : ', minAtCheckout:'Seuil de livraison gratuite confirmé au paiement',
      calculated:'FRAIS DE LIVRAISON CALCULÉS AU PAIEMENT', normalFree:'VOTRE COMMANDE PROFITE DE LA LIVRAISON GRATUITE (',
      bundleFree:'VOTRE LOT PROFITE DE LA LIVRAISON GRATUITE', freeFrom:'LIVRAISON GRATUITE À PARTIR DE ',
      minConfirmed:'SEUIL DE LIVRAISON GRATUITE CONFIRMÉ AU PAIEMENT',
      variantError:'Veuillez choisir une variante disponible pour chaque article.',
      updating:'La sélection de votre produit principal est en cours. Réessayez.',
      addError:'Impossible d’ajouter les articles sélectionnés.',
      unknownError:'Une erreur s’est produite. Veuillez réessayer.',
      cartUpdate:'Impossible de mettre à jour le panier.',
      cartLoad:'Impossible de charger le panier mis à jour.',
      cartUnavailable:'Le contenu du panier est indisponible.'
    },
    ar: {
      inBundle:'موجودة بالفعل في مجموعتك', choose:'اختر القطعة ↗', change:title=>'تغيير المنتج في مجموعتك: '+title,
      option:title=>'اختر خيارًا للمنتج '+title, save:'وفرت ', saveCaps:'التوفير ',
      off:'٪ خصم', max:'خصم يصل إلى 25٪',
      savings:(rate,count)=>'خصم '+rate+'٪ على '+count+' من المنتجات المحددة',
      savingsHint:'أضف قطعة لتحصل على خصم 15٪ · أضف القطعتين لتحصل على 25٪',
      estimated:'تقديري ', progressUnlocked:'حصلت على الشحن المجاني',
      progressTo:'التقدم نحو الشحن المجاني: ', minAtCheckout:'يُؤكَّد الحد الأدنى للشحن المجاني عند الدفع',
      calculated:'تُحسب رسوم الشحن عند الدفع', normalFree:'طلبك مؤهل للشحن المجاني (',
      bundleFree:'مجموعتك مؤهلة للشحن المجاني', freeFrom:'شحن مجاني للطلبات من ',
      minConfirmed:'يُؤكَّد الحد الأدنى للشحن المجاني عند الدفع',
      variantError:'يُرجى اختيار نوع متاح لكل منتج محدد.',
      updating:'يجري تحديث خيار المنتج الرئيسي. حاول مرة أخرى.',
      addError:'تعذّرت إضافة المنتجات المحددة.',
      unknownError:'حدث خطأ ما. يُرجى المحاولة مرة أخرى.',
      cartUpdate:'تعذّر تحديث سلة التسوق.',
      cartLoad:'تعذّر تحميل سلة التسوق المحدثة.',
      cartUnavailable:'محتوى سلة التسوق غير متاح.'
    }
  };

  class ZaisenBundleBuilder extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-zs-main]');
      this.rows = [...this.querySelectorAll('[data-zs-row]')];
      this.extras = [...this.querySelectorAll('[data-zs-optional]')];
      this.mainChoices = this.querySelector('[data-zs-main-variants]');
      this.formComponent = this.closest('.buy-buttons-block')?.querySelector('product-form-component');
      this.form = this.formComponent?.querySelector('form') || null;
      this.errorNode = this.querySelector('[data-zs-error]');
      this.promo = this.querySelector('[data-zs-delivery-zone]');
      this.progress = this.querySelector('[data-zs-progress]');
      this.progressFill = this.querySelector('[data-zs-progress-fill]');
      this.picker = this.querySelector('[data-zs-picker]');
      this.pickerSearch = this.querySelector('[data-zs-picker-search]');
      this.pickerEmpty = this.querySelector('[data-zs-picker-empty]');
      this.activePickerRow = null;
      this.activePickerCollection = 'all';
      this.pickerOpener = null;
      this.processing = false;
      this.t = bundleCopy[(this.dataset.locale || 'en').split('-')[0]] || bundleCopy.en;
      this.currency = (this.dataset.currency || window.Shopify?.currency?.active || 'USD').toUpperCase();
      // Display labels only: variant cents are already converted by Shopify Markets.
      const prefixes = { USD: '$', CAD: 'CAD$', AUD: 'AUD$', EUR: '€', GBP: '£', AED: 'AED ' };
      this.currencyPrefix = prefixes[this.currency] || this.currency + ' ';
      this.isCurrencySymbol = this.currency === 'USD' || this.currency === 'EUR' || this.currency === 'GBP';
      try {
        this.format = new Intl.NumberFormat(this.dataset.locale || 'en-US', {
          style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
        });
        this.wholeFormat = new Intl.NumberFormat(this.dataset.locale || 'en-US', {
          style: 'decimal', maximumFractionDigits: 0
        });
      } catch (_) {
        this.format = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2, maximumFractionDigits: 2
        });
        this.wholeFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
      }

      this.onLocalChange = event => {
        if (event.target.matches('[data-zs-variant]')) {
          const row = event.target.closest('[data-zs-row]');
          const variant = event.target.selectedOptions[0];
          if (row && variant) {
            row.dataset.variantId = variant.value;
            row.dataset.priceCents = variant.dataset.price || row.dataset.priceCents;
          }
        }
        this.refresh();
      };
      this.onFormChange = event => {
        const withinDetails = this.closest('.product-details')?.contains(event.target);
        if (withinDetails && !this.contains(event.target)) {
          this.refresh();
          setTimeout(() => this.refresh(), 80);
          setTimeout(() => this.refresh(), 240);
        }
      };
      this.onVariantUpdate = () => {
        this.refresh();
        setTimeout(() => this.refresh(), 80);
      };
      this.onSubmitCapture = event => {
        if (event.target !== this.form || this.selectedRows().length < 2) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.processing || !this.form?.reportValidity()) return;
        this.purchase('cart');
      };
      this.onClickCapture = event => {
        const target = event.target instanceof Element
          ? event.target.closest('[data-zs-buy-now]') : null;
        if (!target || !this.form?.contains(target) || this.selectedRows().length < 2) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.processing || target.disabled || !this.form.reportValidity()) return;
        this.purchase('checkout');
      };
      this.onPickerClick = event => {
        const change = event.target.closest?.('[data-zs-change]');
        if (change && this.contains(change)) {
          this.openProductPicker(change.closest('[data-zs-optional]'), change);
          return;
        }
        if (!this.picker?.contains(event.target)) return;
        if (event.target.closest?.('[data-zs-picker-close]')) {
          this.picker.close();
          return;
        }
        const category = event.target.closest?.('[data-zs-picker-collection]');
        if (category) {
          this.activePickerCollection = category.dataset.zsPickerCollection || 'all';
          this.renderProductPicker();
          return;
        }
        const candidate = event.target.closest?.('[data-zs-picker-choose]');
        if (candidate) this.choosePickerProduct(candidate);
      };
      this.onPickerInput = () => this.renderProductPicker();
      this.onPickerBackdropClick = event => {
        if (event.target === this.picker) this.picker.close();
      };
      this.onPickerClosed = () => {
        this.activePickerRow = null;
        this.pickerOpener?.focus();
        this.pickerOpener = null;
      };
      this.addEventListener('click', this.onPickerClick);
      this.pickerSearch?.addEventListener('input', this.onPickerInput);
      this.picker?.addEventListener('click', this.onPickerBackdropClick);
      this.picker?.addEventListener('close', this.onPickerClosed);
      this.addEventListener('change', this.onLocalChange);
      document.addEventListener('change', this.onFormChange, true);
      document.addEventListener('variant:update', this.onVariantUpdate);
      document.addEventListener('submit', this.onSubmitCapture, true);
      document.addEventListener('click', this.onClickCapture, true);
      this.refresh();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onPickerClick);
      this.pickerSearch?.removeEventListener('input', this.onPickerInput);
      this.picker?.removeEventListener('click', this.onPickerBackdropClick);
      this.picker?.removeEventListener('close', this.onPickerClosed);
      this.removeEventListener('change', this.onLocalChange);
      document.removeEventListener('change', this.onFormChange, true);
      document.removeEventListener('variant:update', this.onVariantUpdate);
      document.removeEventListener('submit', this.onSubmitCapture, true);
      document.removeEventListener('click', this.onClickCapture, true);
    }
    // Keep both original recommendation slots. Only the contents change.
    openProductPicker(row, opener) {
      if (!row || !this.picker || typeof this.picker.showModal !== 'function') return;
      this.activePickerRow = row;
      this.pickerOpener = opener;
      this.activePickerCollection = 'all';
      if (this.pickerSearch) this.pickerSearch.value = '';
      this.renderProductPicker();
      this.picker.showModal();
      const scrolling = this.picker.querySelector('[data-zs-picker-scroll]');
      if (scrolling) scrolling.scrollTop = 0;
      this.pickerSearch?.focus();
    }

    renderProductPicker() {
      if (!this.picker) return;
      const query = (this.pickerSearch?.value || '').trim().toLocaleLowerCase();
      const selectedElsewhere = new Set(
        this.rows.filter(row => row !== this.activePickerRow)
          .map(row => String(row.dataset.productId || ''))
      );
      const seen = new Set();
      let visibleCount = 0;
      for (const group of this.picker.querySelectorAll('[data-zs-picker-group]')) {
        const inCategory = this.activePickerCollection === 'all' ||
          group.dataset.collection === this.activePickerCollection;
        let groupCount = 0;
        for (const candidate of group.querySelectorAll('[data-zs-picker-choose]')) {
          const productId = String(candidate.dataset.zsPickerProductId || '');
          const title = (candidate.dataset.zsPickerProductTitle || '').toLocaleLowerCase();
          const match = inCategory && title.includes(query) && !seen.has(productId);
          candidate.hidden = !match;
          if (!match) continue;
          seen.add(productId);
          groupCount++;
          visibleCount++;
          const alreadyUsed = selectedElsewhere.has(productId);
          candidate.disabled = alreadyUsed;
          candidate.classList.toggle('is-in-bundle', alreadyUsed);
          const label = candidate.querySelector('.zs-bundle__picker-card-action');
          if (label) label.textContent = alreadyUsed ? this.t.inBundle : this.t.choose;
        }
        group.hidden = !groupCount;
      }
      for (const tab of this.picker.querySelectorAll('[data-zs-picker-collection]')) {
        const active = tab.dataset.zsPickerCollection === this.activePickerCollection;
        tab.setAttribute('aria-pressed', String(active));
        tab.classList.toggle('is-active', active);
      }
      if (this.pickerEmpty) this.pickerEmpty.hidden = visibleCount > 0;
    }

    choosePickerProduct(candidate) {
      const row = this.activePickerRow;
      if (!row || candidate.disabled) return;
      const id = String(candidate.dataset.zsPickerProductId || '');
      if (!/^\d+$/.test(id) || this.rows.some(other =>
        other !== row && String(other.dataset.productId || '') === id
      )) return;
      const template = candidate.querySelector('template[data-zs-picker-variants]');
      const selectSource = template?.content?.querySelector('select');
      const available = [...(selectSource?.options || [])].find(option => !option.disabled);
      if (!available || !/^\d+$/.test(available.value)) return;

      const title = candidate.dataset.zsPickerProductTitle || 'ZAISEN product';
      const price = available.dataset.price || '0';
      if (!/^\d+$/.test(price) || Number(price) <= 0) return;
      const photo = candidate.dataset.zsPickerProductImage || '';
      row.dataset.productId = id;
      row.dataset.variantId = available.value;
      row.dataset.priceCents = price;

      const name = row.querySelector('.zs-bundle__name');
      if (name) name.textContent = title;
      const check = row.querySelector('[data-zs-check]');
      if (check) {
        check.disabled = false;
        check.checked = true;
        check.setAttribute('aria-label', 'Include ' + title + ' in bundle');
      }
      const button = row.querySelector('[data-zs-change]');
      if (button) button.setAttribute('aria-label', this.t.change(title));
      const picture = row.querySelector('.zs-bundle__picture');
      if (picture) {
        if (photo) {
          const image = document.createElement('img');
          image.src = photo;
          image.alt = title;
          image.loading = 'lazy';
          picture.replaceChildren(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.textContent = 'ZAISEN';
          picture.replaceChildren(placeholder);
        }
      }
      let variants = row.querySelector('.zs-bundle__variants');
      if (selectSource.options.length > 1) {
        if (!variants) {
          variants = document.createElement('span');
          variants.className = 'zs-bundle__variants';
          row.querySelector('.zs-bundle__price-group')?.before(variants);
        }
        const select = selectSource.cloneNode(true);
        select.setAttribute('data-zs-variant', '');
        select.setAttribute('aria-label', this.t.option(title));
        select.value = available.value;
        variants.replaceChildren(select);
      } else {
        variants?.remove();
      }
      this.picker?.close();
      this.refresh();
    }

    money(cents) {
      return this.currencyPrefix + this.format.format(Math.round(cents) / 100);
    }

    // Small code and full-size amount; leave bundle rows and totals intact.
    showMoney(element, cents, leading = '') {
      if (!element) return;
      const prefix = document.createElement('span');
      prefix.className = 'zs-bundle__currency-prefix' +
        (this.isCurrencySymbol ? ' zs-bundle__currency-prefix--symbol' : '');
      prefix.textContent = this.currencyPrefix;
      element.replaceChildren(
        document.createTextNode(leading),
        prefix,
        document.createTextNode(this.format.format(Math.round(cents) / 100))
      );
    }

    shippingMinimumLabel(localCents) {
      return this.currencyPrefix + this.wholeFormat.format(Math.ceil(localCents / 100)) + '+';
    }

    syncMainVariant() {
      const chosenId = this.form?.querySelector('input[name="id"]')?.value;
      const option = [...(this.mainChoices?.options || [])].find(o => o.value === chosenId);
      if (option && this.main) {
        this.main.dataset.variantId = option.value;
        this.main.dataset.priceCents = option.dataset.price;
        this.mainChoices.value = option.value;
      }
    }

    selectedRows() {
      return this.rows.filter(row =>
        row.hasAttribute('data-zs-main') ||
        (!!row.querySelector('[data-zs-check]')?.checked &&
         !row.querySelector('[data-zs-check]')?.disabled));
    }

    quantity() {
      const field = this.form?.querySelector('input[name="quantity"]');
      const qty = Number(field?.value || '1');
      return Number.isInteger(qty) && qty > 0 ? Math.min(qty, 999) : 1;
    }

    refresh() {
      if (!this.main) return;
      this.syncMainVariant();
      const selected = this.selectedRows();
      const count = selected.length;
      const rate = count === 3 ? 25 : count === 2 ? 15 : 0;
      const mainQty = this.quantity();
      let before = 0, after = 0;

      for (const row of this.rows) {
        const checked = selected.includes(row);
        row.classList.toggle('zs-bundle__row--unselected', !checked);
        const unit = Number(row.dataset.priceCents) || 0;
        const discounted = checked ? Math.round(unit * (100 - rate) / 100) : unit;
        const units = row === this.main ? mainQty : 1;
        if (checked) {
          before += unit * units;
          after += discounted * units;
        }
        const oldPrice = row.querySelector('[data-zs-original]');
        const price = row.querySelector('[data-zs-price]');
        const saved = row.querySelector('[data-zs-saved]');
        if (oldPrice) {
          this.showMoney(oldPrice, unit);
          oldPrice.hidden = !checked || !rate;
        }
        this.showMoney(price, discounted);
        if (saved) {
          if (checked && rate) this.showMoney(saved, (unit - discounted) * units, this.t.save);
          else saved.textContent = '';
        }
      }

      const tier = this.querySelector('[data-zs-tier]');
      if (tier) tier.textContent = rate ? rate + this.t.off : this.t.max;
      const desc = this.querySelector('[data-zs-tier-description]');
      if (desc) desc.textContent = rate
        ? this.t.savings(rate, count)
        : 'Add 1 piece: 15% off · Add both: 25% off';
      const regular = this.querySelector('[data-zs-regular-total]');
      this.showMoney(regular, before);
      const total = this.querySelector('[data-zs-bundle-total]');
      this.showMoney(total, after);
      const savings = this.querySelector('[data-zs-save-total]');
      if (savings) {
        if (rate) this.showMoney(savings, before - after, this.t.saveCaps);
        else savings.textContent = '—';
      }

      this.currentRate = rate;
      this.selectedTotal = after;
      this.updateShipping(count, after);

      // The original Add to Cart and Buy Now buttons stay present, active,
      // and controlled by the native product form and variant availability.
      if (this.errorNode) {
        this.errorNode.hidden = true;
        this.errorNode.textContent = '';
      }
    }

    updateShipping(count, totalCents) {
      const supported = this.dataset.freeShipping === 'true';
      const thresholdUSD = Number(this.dataset.shippingThresholdCents) || 0;
      const currency = this.currency;
      const marketRate = Number(window.Shopify?.currency?.rate);
      // Shopify's own storefront rate can help estimate progress in local currencies.
      // Avoid assuming that $60 USD and €60 are equivalent if the rate isn't available.
      const thresholdLocal = currency === 'USD' ? thresholdUSD :
        Number.isFinite(marketRate) && marketRate > 0 && marketRate < 5000
          ? thresholdUSD * marketRate : null;
      const normalEligible = supported && thresholdLocal != null &&
        thresholdLocal > 0 && totalCents >= thresholdLocal;
      const bundleEligible = supported && count >= 2;
      const unlocked = normalEligible || bundleEligible;
      const percentage = !supported ? 0 : unlocked ? 100 :
        thresholdLocal != null && thresholdLocal > 0
          ? Math.max(0, Math.min(99, Math.round(totalCents / thresholdLocal * 100)))
          : 0;
      const label = this.querySelector('[data-zs-shipping-label]');
      const check = this.querySelector('[data-zs-shipping-check]');
      const formattedThreshold = thresholdLocal != null && thresholdLocal > 0
        ? this.shippingMinimumLabel(thresholdLocal) : null;
      const thresholdDescription = formattedThreshold
        ? (currency === 'USD' ? formattedThreshold : this.t.estimated + formattedThreshold)
        : null;
      this.promo?.classList.toggle('is-unlocked', unlocked);
      if (check) {
        check.hidden = !unlocked;
        // Only one checkmark: the circular icon. Never duplicate it in text.
        check.textContent = '✓';
      }
      if (this.progress) {
        this.progress.setAttribute('aria-valuenow', String(percentage));
        this.progress.setAttribute('aria-label', unlocked
          ? 'Free shipping unlocked'
          : thresholdDescription
            ? this.t.progressTo + thresholdDescription
            : 'Free shipping minimum confirmed at checkout');
      }
      if (this.progressFill) this.progressFill.style.width = percentage + '%';
      if (!label) return;
      if (!supported) {
        label.textContent = 'SHIPPING CALCULATED AT CHECKOUT';
      } else if (normalEligible) {
        label.textContent = this.t.normalFree + thresholdDescription + ')';
      } else if (bundleEligible) {
        label.textContent = 'YOUR BUNDLE QUALIFIES FOR FREE SHIPPING';
      } else {
        label.textContent = thresholdDescription
          ? this.t.freeFrom + thresholdDescription
          : 'FREE SHIPPING MINIMUM CONFIRMED AT CHECKOUT';
      }
    }

    lines() {
      const selected = this.selectedRows();
      const variants = selected.map(row => String(row.dataset.variantId || ''));
      if (variants.some(id => !/^\d+$/.test(id)) || new Set(variants).size !== variants.length) {
        throw new Error('Please choose an available variant for each selected product.');
      }
      const formData = new FormData(this.form);
      const mainId = String(formData.get('id') || '');
      if (!mainId || mainId !== variants[0]) {
        throw new Error('Your main product option is updating. Please try again.');
      }
      const properties = {};
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[([^\]]+)\]$/);
        if (match && typeof value === 'string' && value) properties[match[1]] = value;
      }
      const main = {id:Number(mainId),quantity:this.quantity()};
      if (Object.keys(properties).length) main.properties = properties;
      const sellingPlan = formData.get('selling_plan');
      if (sellingPlan) main.selling_plan = Number(sellingPlan);
      return [main, ...variants.slice(1).map(id => ({id:Number(id),quantity:1}))];
    }

    async purchase(destination) {
      if (this.processing || this.selectedRows().length < 2) return;
      let items;
      try { this.syncMainVariant(); items = this.lines(); }
      catch (error) { this.showError(error.message); return; }
      this.processing = true;
      const buttons = [...this.form.querySelectorAll('button[name="add"],[data-zs-buy-now]')];
      const disabledBefore = buttons.map(button => button.disabled);
      buttons.forEach(button => {button.disabled = true; button.setAttribute('aria-busy','true');});
      const root = window.Shopify?.routes?.root || this.dataset.cartPath?.replace(/cart\/?$/, '') || '/';
      const base = root.endsWith('/') ? root : root + '/';
      const discount = this.currentRate === 25 ? 'ZS-BUNDLE25-2026' : 'ZS-BUNDLE15-2026';
      const codes = [discount];
      if (this.dataset.freeShipping === 'true') codes.push('ZS-BUNDLESHIP-2026');

      try {
        const addResponse = await fetch(base + 'cart/add.js', {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})
        });
        const added = await addResponse.json();
        if (!addResponse.ok || added.status) {
          throw new Error(added.description || added.message || 'Could not add the selected products.');
        }
        // Shopify supports multiple comma-separated discount codes in cart/update.js.
        const updateResponse = await fetch(base + 'cart/update.js', {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({discount:codes.join(',')})
        });
        const updated = await updateResponse.json();
        if (!updateResponse.ok || updated.status) {
          throw new Error('Products were added, but the bundle discount could not be applied. Please review your cart.');
        }
        if (destination === 'checkout') {
          window.location.assign(base + 'checkout');
          return;
        }
        await this.openCartDrawer(base);
        this.processing = false;
        buttons.forEach((button, index) => {
          button.disabled = disabledBefore[index];
          button.removeAttribute('aria-busy');
        });
      } catch (error) {
        this.processing = false;
        buttons.forEach((button, index) => {
          button.disabled = disabledBefore[index];
          button.removeAttribute('aria-busy');
        });
        this.showError(error?.message || 'Something went wrong. Please try again.');
      }
    }

    /**
     * Keep bundle Add to Cart on the product page and show the latest
     * Shopify-calculated discounts in the native ZAISEN side drawer.
     * Buy Now continues to checkout.
     */
    async openCartDrawer(base) {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) {
        window.location.assign(base + 'cart');
        return;
      }

      const response = await fetch(base + '?sections=cart-drawer-section', {
        credentials: 'same-origin',
        headers: {'Accept': 'application/json'}
      });
      if (!response.ok) throw new Error('Could not update the cart drawer.');
      const sections = await response.json();
      const renderedHtml = sections['cart-drawer-section'];
      if (typeof renderedHtml !== 'string' || !renderedHtml) {
        throw new Error('Could not load the updated cart drawer.');
      }

      const parsed = new DOMParser().parseFromString(renderedHtml, 'text/html');
      const replacement = parsed.querySelector('#cart-drawer .cart-drawer__inner');
      const current = drawer.querySelector('.cart-drawer__inner');
      if (!replacement || !current) throw new Error('Cart drawer content unavailable.');

      current.replaceWith(replacement);

      // Bundle form uses Ajax directly rather than the native Horizon
      // product-form events: synchronize the header count ourselves.
      try {
        const cartResponse = await fetch(base + 'cart.js', {
          credentials: 'same-origin',
          headers: {'Accept': 'application/json'}
        });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          const icon = document.querySelector('cart-icon');
          if (icon?.renderCartBubble) icon.renderCartBubble(cart.item_count, true);
        }
      } catch (_) {
        // The visible drawer still contains Shopify's latest rendered cart.
      }

      await customElements.whenDefined('theme-drawer');
      drawer.open();
    }

    showError(message) {
      if (!this.errorNode) return;
      this.errorNode.hidden = false;
      this.errorNode.textContent = message;
    }
  }
  customElements.define('zs-bundle-builder', ZaisenBundleBuilder);
})();
